import isPlainObject from 'lodash/isPlainObject';

import StakeHorsesWithoutMarks from 'atg/api/StakeHorsesWithoutMarks';
import { getText, hasText } from 'shared/utils/Text';

import { debug } from './Utils';

export default class RequestError {
  constructor(request, status, statusText, responseText) {
    if (!status) {
      this.data = request;
      debug(request);
    } else {
      this.text = responseText;

      if (isPlainObject(this.text)) {
        this.data = this.text;
      } else {
        try {
          this.data = JSON.parse(this.text);
        } catch {
          this.data = {};
        }
      }

      this.statusCode = status;
      this.statusText = statusText;
      this.statusJQ = status;
      this.method = request.method;
      this.path = request.path;
    }
  }

  getMessage() {
    if (this.data.messageId && hasText(this.data.messageId)) {
      return getText(this.data.messageId);
    }

    if (this.data.message) {
      return this.data.message;
    }

    if (this.data.messageId) {
      return getText('error-message-unknown-id', this.data.messageId);
    }

    return getText('error-message-generic');
  }

  getDetails() {
    if (
      this.data.messageId === 'warning-system_contains_horses_without_marks'
    ) {
      let str = '';
      const horsesWithoutMarks = this.getErrorData();

      if (horsesWithoutMarks instanceof StakeHorsesWithoutMarks) {
        const legNumbers = horsesWithoutMarks.getMissingHorsesLegNumbers();

        for (const legNr of legNumbers) {
          let startNumbers =
            horsesWithoutMarks.getMissingHorsesLegStartNumbers(legNr);

          startNumbers = startNumbers.join(', ');
          str += getText(
            'warning-system_contains_horses_without_marks-details-leg',
            legNr,
            startNumbers,
          );
        }

        str += getText(
          'warning-system_contains_horses_without_marks-details-end',
        );
      }

      return str;
    }

    let detailsId;

    if (this.data.messageId) {
      detailsId = `${this.data.messageId}-details`;
    }

    if (detailsId && hasText(detailsId)) {
      return getText(detailsId);
    }

    if (this.data.details) {
      return this.data.details;
    }

    return;
  }

  getErrorType() {
    return this.data.type;
  }

  getErrorData() {
    return this.data.errorData;
  }

  getLogNumber() {
    return this.data.logNumber;
  }

  getStatusCode() {
    return this.statusCode;
  }

  getException() {
    return this.data.exception;
  }

  getPath() {
    return this.path;
  }

  getMethod() {
    return this.method;
  }

  getTime() {
    return this.data.timestamp ? new Date(this.data.timestamp) : new Date();
  }
}
